import React from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Subtitle,
    Input,
} from '@panwds/react-ui';
import useModalBackdropClose from '../../shared/hooks/useModalBackdropClose';
import { MODAL_BORDER_CLASS } from './utils/modalLayout';

const EmailOTPModal = ({ subscriptionFlow }) => {
    const {
        email,
        setEmail,
        otp,
        setOTP,
        isEmailModalOpen,
        showOTPInput,
        countdown,
        startCountdown,
        formatCountdown,
        handleSendOTP,
        handleEmailSubmit,
        closeEmailModal,
    } = subscriptionFlow;

    useModalBackdropClose(isEmailModalOpen, closeEmailModal);

    return (
        <Modal
            onClose={closeEmailModal}
            isOpen={isEmailModalOpen}
            addClassName={MODAL_BORDER_CLASS}
            style={{ marginTop: '50px' }}
            eventsToClose={{ enableClickOutside: true, enableEscapeKey: true }}
        >
            <ModalHeader title="Sign In" />
            <ModalBody>
                <span className="ssmutw-text-sm">
                    <Subtitle size="sm" addClassName="ssmutw-font-extralight">
                        Sign in to be able to subscribe to Incident and Maintenance notifications for Prisma SASE products
                    </Subtitle>
                    <div className="ssmutw-pt-2 ssmutw-mt-3 ssmutw-font-bold">
                        Email address:
                    </div>
                </span>
                <div className="ssmutw-mt-3 emailinput">
                    <Input
                        value={email}
                        type="email"
                        size="lg"
                        aria-label="Email address"
                        placeholder="Enter email address"
                        onChange={(ev) => {
                            const value = ev?.currentTarget?.value || '';
                            localStorage.setItem('email', value);
                            setEmail(value);
                        }}
                    />
                </div>
                <div className="ssmutw-mt-3 emailinput">
                    {showOTPInput && (
                        <>
                            <span className="ssmutw-text-sm">One-Time Password (OTP):</span>
                            <div className="ssmutw-mt-3 emailinput">
                                <Input
                                    value={otp}
                                    type="number"
                                    size="lg"
                                    aria-label="OTP"
                                    placeholder="Enter 6-digit code"
                                    onChange={(ev) => {
                                        const value = ev?.currentTarget?.value || '';
                                        setOTP(value);
                                    }}
                                />
                            </div>
                            <div className="ssmutw-mt-3">
                                {startCountdown ? (
                                    <Subtitle size="sm">
                                        OTP expires in {formatCountdown(countdown)}
                                    </Subtitle>
                                ) : (
                                    <Subtitle size="sm" addClassName="ssmutw-text-red-500">
                                        OTP has expired
                                    </Subtitle>
                                )}
                                <span
                                    className="ssmutw-pl-4 ssmutw-text-[13px] ssmutw-float-right ssmutw-cursor-pointer ssmutw-underline"
                                    style={{ color: 'var(--ssmu-text-link)' }}
                                    onClick={() => handleSendOTP(email)}
                                >
                                    Resend OTP
                                </span>
                            </div>
                        </>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button onClick={closeEmailModal} appearance="secondary">
                    Cancel
                </Button>
                <Button appearance="primary" onClick={handleEmailSubmit}>
                    {showOTPInput ? 'Verify and Sign In' : 'Request One-Time Password'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default React.memo(EmailOTPModal);
